import React from 'react';
import { Typography, makeStyles } from '@material-ui/core';
import { useTheme } from '@material-ui/core/styles';
import { NewModal, Button, TextButton } from 'common/components';
import { useContent } from 'content/content-provider';

const styles = makeStyles(({ spacing, palette }) => ({
  button: {
    marginTop: spacing(5),
    backgroundColor: palette.error.main,
    '&:hover, &:active': {
      backgroundColor: `${palette.error.main} !important`,
    },
    '&:hover.Mui-disabled': {
      backgroundColor: `${palette.error.main} !important`,
      opacity: '0.5',
    },
  },
  textButton: {
    marginTop: spacing(2),
    textAlign: 'center',
  },
  removeGiftCardModal: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: `${spacing(6)}px ${spacing(6)}px ${spacing(6)}px ${spacing(6)}px`,
  },
  modal: {
    borderRadius: '16px',
  },
  subTitle: {
    marginTop: spacing(4),
    textAlign: 'center',
  },
}));

interface RemoveGiftCardModalProps {
  isOpen: boolean;
  handleClose: () => void;
  handleRemove: () => void;
  isLoading: boolean;
}

const RemoveGiftCardModal = ({
  isOpen,
  handleClose,
  handleRemove,
  isLoading,
}: RemoveGiftCardModalProps) => {
  const [content] = useContent();
  const classes = styles();
  const theme = useTheme();

  return (
    <NewModal
      open={isOpen}
      handleClose={handleClose}
      showHeader={false}
      PaperProps={{ className: classes.modal }}
      dataTestId="remove-gift-card"
    >
      <div className={classes.removeGiftCardModal}>
        <Typography variant="h2" component="h1">
          {content.removeGiftCard.title}
        </Typography>
        <Typography className={classes.subTitle}>{content.removeGiftCard.subTitle}</Typography>
        <Button className={classes.button} onClick={handleRemove} isLoading={isLoading}>
          {content.removeGiftCard.removeButton}
        </Button>
        <div>
          <TextButton
            labelColor={theme.palette.text.primary}
            className={classes.textButton}
            onClick={handleClose}
          >
            {content.removeGiftCard.cancel}
          </TextButton>
        </div>
      </div>
    </NewModal>
  );
};

export default RemoveGiftCardModal;
